import { PieChart, Pie, Cell } from "recharts";

const GRADE_CONFIG = {
    A: { color: "#22c55e", bg: "#f0fdf4" },
    B: { color: "#3b82f6", bg: "#eff6ff" },
    C: { color: "#eab308", bg: "#fefce8" },
    D: { color: "#f97316", bg: "#fff7ed" },
    F: { color: "#ef4444", bg: "#fef2f2" },
};

const getGrade = (score) => {
    if (score >= 90) return "A";
    if (score >= 80) return "B";
    if (score >= 70) return "C";
    if (score >= 60) return "D";
    return "F";
};

const SecurityScoreGauge = ({ score, size = 180 }) => {
    const safeScore = score ?? 0;
    const grade = getGrade(safeScore);
    const config = GRADE_CONFIG[grade];
    const data = [
        { value: safeScore },
        { value: 100 - safeScore },
    ];

    return (
        <div className="relative flex flex-col items-center">
            <PieChart width={size} height={size / 2 + 10}>
                <Pie
                    data={data}
                    cx={size / 2}
                    cy={size / 2}
                    startAngle={180}
                    endAngle={0}
                    innerRadius={size * 0.3}
                    outerRadius={size * 0.44}
                    dataKey="value"
                    stroke="none"
                >
                    <Cell fill={config.color} />
                    <Cell fill="#e5e7eb" />
                </Pie>
            </PieChart>
            <div
                className="absolute flex flex-col items-center"
                style={{ top: size * 0.28 }}
            >
                <span className="text-3xl font-bold" style={{ color: config.color }}>
                    {safeScore}
                </span>
                <span
                    className="text-xs font-semibold px-2 py-0.5 rounded-full"
                    style={{ backgroundColor: config.bg, color: config.color }}
                >
                    Grade {grade}
                </span>
            </div>
        </div>
    );
};

export default SecurityScoreGauge;
